/**
 * @see https://umijs.org/docs/max/access#access
 * */
export default function access(
  initialState: { currentUser?: API.CurrentUser } | undefined,
) {
  const { currentUser } = initialState ?? {};
  return {
    canAdmin: currentUser && (currentUser.access === 'admin' || currentUser.access === 'superadmin'),
    canSuperAdmin: currentUser && currentUser.access === 'superadmin',
  };
}
